import { Button, Typography } from '@mui/material';
import { Box, Stack } from '@mui/system';
import { TixSelector } from '@tix-ticketing/ui-components';
import { bindToggle, usePopupState } from 'material-ui-popup-state/hooks';
import { FormattedMessage } from 'react-intl';
import { EventFilterButton } from 'components/events-list/event-filter-button';
export const EventsPaginatedDayFilterSelector = ({
  days,
  setDays,
  daysFilterOptions
}: {
  days: string | null;
  setDays: (day: string | null) => void;
  daysFilterOptions: {
    value: string | null;
    label: React.ReactNode;
  }[];
}) => {
  const daysState = usePopupState({
    variant: 'popper',
    popupId: 'daysFilterSelector'
  });
  return <TixSelector triggerElement={<EventFilterButton active={daysState.isOpen} clearable={days !== null} onClear={() => {
    daysState.close();
    setDays(null);
  }} label={days !== null ? daysFilterOptions.find(i => i.value === days)?.label : <FormattedMessage id="event.filter.days" defaultMessage={[{
    "type": 0,
    "value": "Days"
  }]} />} {...bindToggle(daysState)} />} open={daysState.isOpen} onClose={() => {
    daysState.close();
  }} localeState={daysState} hideCloseButton popperPlacement="bottom-start" popperMaxWidth={288}>
      <Stack sx={{
      flexDirection: 'column',
      alignItems: 'center',
      gap: 1
    }}>
        <Typography variant="h6">
          <FormattedMessage id="event.filter.whatDay" defaultMessage={[{
          "type": 0,
          "value": "What day?"
        }]} />
        </Typography>
        <Typography variant="body2" align="center" sx={{
        mb: 1.5
      }}>
          <FormattedMessage id="event.filter.whatDayInfo" defaultMessage={[{
          "type": 0,
          "value": "Only show dates with selected days"
        }]} />
        </Typography>
        <Box sx={{
        width: '100%',
        display: 'grid',
        gridTemplateColumns: '1fr 1fr',
        gap: 1
      }}>
          {daysFilterOptions.map(option => <Button key={option.value} variant={days === option.value ? 'outlined' : 'text'} color={days === option.value ? 'primary' : 'monochrome'} size="medium" onClick={() => {
          setDays(option.value);
          daysState.close();
        }} fullWidth>
              {option.label}
            </Button>)}
        </Box>
      </Stack>
    </TixSelector>;
};